import { ModuleHeaderSlot, Switch } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CompilationModel, useUpdateCompilation } from "@tm/data/compilations"
import { useState } from "react"
import { isWM } from "../../../../utils"

export function CompilationSettings({ selectedCompilation }: { selectedCompilation: CompilationModel }) {
    const { translateText } = useLocalization()
    const { updateCompilation } = useUpdateCompilation(isWM())
    const [isLoading, setIsLoading] = useState(false)

    async function handlePrivacyChange() {
        setIsLoading(true)
        try {
            await updateCompilation({
                ...selectedCompilation,
                compilationId: selectedCompilation.id,
                isPublic: !selectedCompilation.isPublic,
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <ModuleHeaderSlot title={translateText(1254)}>
            {/* Is Public */}
            <Switch checked={selectedCompilation.isPublic} onChange={handlePrivacyChange} disabled={isLoading} />
        </ModuleHeaderSlot>
    )
}
